var _circle, _rect, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckMarkCircle = function SvgCheckMarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#CheckMarkCircle_svg__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.586,
    y: 13.566,
    width: 2,
    height: 7.9,
    rx: 1,
    transform: "rotate(-45 6.586 13.566)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.615,
    y: 19.098,
    width: 2,
    height: 13.036,
    rx: 1,
    transform: "rotate(-134.111 12.615 19.098)",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CheckMarkCircle_svg__a",
    x1: -2,
    y1: 12,
    x2: 28,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgCheckMarkCircle;